export const getUploadType = ({ addImageModalReducer: { type } }) => type || 'users';
